import AsyncStorage from "@react-native-async-storage/async-storage";

export interface LocalKeyValueStore {
	get<T>(key: string): Promise<T | null>;
	merge<T>(key: string, value: T): Promise<void>;
	remove(key: string): Promise<void>;
	set<T>(key: string, value: T): Promise<void>;
}

/**
 * A simple key-value store using AsyncStorage.
 * This is used to persist data across app sessions.
 * It provides methods to get, set, remove, and merge values.
 * Works with Web, iOS, and Android, Mac OS, and Windows platforms.
 */
export const LocalStorage: LocalKeyValueStore = {
	get: async <T>(key: string): Promise<T | null> => {
		const value = await AsyncStorage.getItem(key);
		if (value === null) {
			return null;
		}
		return JSON.parse(value) as T;
	},

	set: async <T>(key: string, value: T): Promise<void> => {
		await AsyncStorage.setItem(key, JSON.stringify(value));
	},

	remove: async (key: string): Promise<void> => {
		await AsyncStorage.removeItem(key);
	},
	/**
	 * merges objects, needs to be cleaned up to work with primitive types
	 */
	merge: async <T>(key: string, value: T): Promise<void> => {
		const existing = await LocalStorage.get<T>(key);
		const merged = { ...existing, ...value };
		await LocalStorage.set(key, merged);
	},
};
